export const SET_VIEW_MODE = 'SET_VIEW_MODE';
export const SET_GROUPED = 'SET_GROUPED';

